export default {"id":"icon-logo-icon"}